var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-page"},[_c('Menu',{attrs:{"title":"评价信息","home":true}}),_c('div',{staticClass:"container-flex"},[_vm._v("\n    ddd\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }